<template>
  <div>
    <b-card no-body class="cards card-box">
      <div class="py-2">
        <b-button variant="primary" @click="abrirCadastrar" v-if="permissao.c">{{
          $t("GERAL.NOVO")
        }}</b-button>
      </div>

      <div class="row">
        <filtro-empresas class="col-12 col-md-4" v-if="ehAdmin" @update="listar()" />
      </div>

      <tabela-padrao
        sem-selecionar-todos
        v-model="tabela.dados"
        :colunas="tabela.colunas"
        :quantidade-itens="tabela.quantidadeItens"
        ref="tabela"
        backend-paginado
        @paginar="listar"
        @doisClicksLinha="abrirEditar"
      >
        <template #cell(acoes)="linha">
          <div class="d-flex">
            <div
              :style="{ visibility: !linha.item.usuarioAssociado ? 'visible' : 'hidden' }"
            >
              <b-button
                variant="flat-info"
                v-if="permissaoUsuario.c"
                @click="novoUsuario(linha.item)"
              >
                <i class="fas fa-user-plus"></i>
              </b-button>
            </div>
            <b-button
              variant="flat-primary"
              v-if="permissao.r"
              @click="abrirEditar(linha.item)"
            >
              <i class="fas fa-edit"></i>
            </b-button>
            <b-button
              variant="flat-danger"
              v-if="permissao.d"
              @click="excluir(linha.item)"
            >
              <i class="fas fa-trash"></i>
            </b-button>
          </div>
        </template>
        <template #cell(usuarioAssociado)="linha">
          <div>
            <b-badge :variant="linha.value ? 'success' : 'danger'">{{
              linha.value ? "Possui usuário" : "Não possui usuário"
            }}</b-badge>
          </div>
        </template>
      </tabela-padrao>
    </b-card>
  </div>
</template>

<script>
import Confirmacao from "@/components/confirmacao/Confirmacao";
import PessoaService from "@/common/services/pessoa/pessoa.service";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import Swal from "sweetalert2";
//import helpers from "@/common/utils/helpers";
import UsuarioService from "@/common/services/usuario/usuario.service";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import helpers from "../../common/utils/helpers";
export default {
  name: "Pessoas",
  mixins: [AlertasMixin],
  data() {
    return {
      tabela: {
        dados: [],
        colunas: [
          {
            key: "nome",
            label: "Nome",
          },
          {
            key: "email",
            label: "E-mail",
          },
          {
            key: "endereco.cidade",
            label: "Cidade",
          },
          {
            key: "titulacao",
            label: "Titulação",
            formatter: (v) => {
              return helpers.getEnum(v)?.text;
            },
          },
          {
            key: "usuarioAssociado",
            label: "",
          },
          {
            key: "acoes",
            label: this.$t("GERAL.ACOES"),
            tdClass: "acoes",
          },
        ],
        quantidadeItens: 0,
        paginaAtual: 0,
        porPagina: 0,
      },
    };
  },
  mounted() {
    this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: this.$t("MENU.PESSOAS") }]);
    this.listar();
  },
  methods: {
    novoUsuario: function (item) {
      this.confirmar("Deseja criar um usuário para esta pessoa?").then((confirmado) => {
        if (!confirmado) return;

        if (!item.email) {
          this.alertaErro("Para criar um usuário, é necessário informar o email");
          return;
        }

        let form = {
          pessoaId: item.id,
        };

        this.$store.dispatch(START_LOADING);
        UsuarioService.novoUsuario(form)
          .then(() => {
            this.alertaSucesso("Email de criação de usuário encaminhado!");
          })
          .catch(() => {
            this.alertaErro("Erro ao criar usuário");
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      });
    },
    listar: function (paginaAtual = 0, porPagina = 10) {
      if (!this.empresaSelecionada) return;

      this.$store.dispatch(START_LOADING);
      PessoaService.listar(this.empresaSelecionada, porPagina, paginaAtual)
        .then((res) => {
          this.tabela.dados = res.data.data.itens;
          this.paginaAtual = paginaAtual;
          this.porPagina = porPagina;
          this.tabela.quantidadeItens = res.data.data.paginacao.totalDeElementos;
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    abrirCadastrar() {
      this.$router.push({ name: "pessoas-formulario" });
    },
    abrirEditar(item) {
      this.$router.push({ name: "pessoas-formulario", params: { id: item.id } });
    },
    excluir(item) {
      Confirmacao.SimNao(
        this,
        null,
        this.$t("PESSOAS.CONFIRMAR_EXCLUIR").formatUnicorn({
          nome: item.nome,
        })
      ).then(async (result) => {
        if (result.value) {
          this.$store.dispatch(START_LOADING);
          PessoaService.excluir(item.id)
            .then(() => {
              Swal.fire({
                title: this.$t("GERAL.SUCCESSO"),
                text: this.$t("PESSOAS.MENSAGEM_EXCLUIDO"),
                icon: "success",
                confirmButtonText: this.$t("GERAL.OK"),
              }).then((result) => {
                if (result.isConfirmed) {
                  this.listar();
                }
              });
            })
            .catch((err) => {
              Swal.fire({
                title: this.$t("GERAL.ERRO"),
                text: err.response.data.errors,
                icon: "error",
              });
            })
            .finally(() => {
              this.$store.dispatch(STOP_LOADING);
            });
        }
      });
    },
  },
  computed: {
    empresaSelecionada: function () {
      return this.$store.state.app.selectedCompanyObj?.id;
    },
    ehAdmin() {
      return this.$store.getters["app/ehAdmin"];
    },
    permissao() {
      return this.$store.getters["app/retornaPermissao"]("Pessoas");
    },
    permissaoUsuario() {
      return this.$store.getters["app/retornaPermissao"]("Usuarios");
    },
  },
};
</script>
